import imageApi from '@/api/imageApi'
export default {
  namespaced: true,

  state: {
    loading: null
  },
  getters: {
    loading: state => state.loading
  },
  mutations: {

    SET_LOADING (state, value) {
      state.loading = value
    }
  },
  actions: {
    async deleteImage ({ commit }, $id) {
      commit('SET_LOADING', true)
      await imageApi.delete($id)
      commit('SET_LOADING', false)
      return true
    }
  }

}
